<style scoped>
.goods .vview-formitem {
    margin-bottom: 6px;
}
.demo-spin-icon-load {
    animation: ani-demo-spin 1s linear infinite;
}
@keyframes ani-demo-spin {
    from {
        transform: rotate(0deg);
    }
    50% {
        transform: rotate(180deg);
    }
    to {
        transform: rotate(360deg);
    }
}
</style>
<template>
    <!-- 退货 -->
    <div>
        <div
            :class="{
                goods:
                    type == 'query' ||
                    oldreturnStatus == 'RETURNED' ||
                    oldreturnStatus == 'NULLIFY' ||
                    oldreturnStatus == 'RETURNING',
            }"
        >
            <vForm
                :label-width="120"
                :model="formData"
                class="margin-20 clearfix"
                :class="{ queryform: type == 'query' }"
                ref="returnform"
            >
                <vCol span="24">
                    <vCol span="12">
                        <div
                            class="font-14 font-bold padding-bottom-10 b2ccolor-dark-primary"
                        >
                            {{
                                $t("erp.aftersales.goodsorder", {
                                    defaultValue: "退货单",
                                })
                            }}
                            <span
                                v-if="type == 'query'"
                                class="font-12 b2color-black margin-right-10"
                                >(
                                <span v-if="type == 'query'">{{
                                    filterStatus(formData.returnStatus)
                                }}</span>
                                )</span
                            >
                            <span
                                v-if="
                                    type == 'query' &&
                                    oldreturnStatus == 'RETURNED'
                                "
                            >
                                <vButton
                                    class="margin-right-5"
                                    slot="append"
                                    theme="info"
                                    @click="repush"
                                    >{{
                                        $t("erp.orderService.rePush", {
                                            defaultValue: "重送",
                                        })
                                    }}</vButton
                                >
                            </span>
                            <span
                                v-if="
                                    type == 'query' &&
                                    oldreturnStatus == 'NORETURN'
                                "
                            >
                                <vButton
                                    slot="append"
                                    theme="primary"
                                    :disabled="buyLabelLoading"
                                    @click="buyNewLabel"
                                    >{{
                                        $t("erp.aftersales.buyfaceorder", {
                                            defaultValue: "购买面单",
                                        })
                                    }}</vButton
                                >
                                <vButton
                                    slot="append"
                                    theme="info"
                                    class="margin-left-5 margin-right-5"
                                    @click="submitGoods"
                                    >{{
                                        $t("erp.aftersales.submitgoods", {
                                            defaultValue: "提交退货",
                                        })
                                    }}</vButton
                                >
                            </span>
                            <span v-if="type == 'query'">
                                <vButton
                                    v-show="
                                        formData.reservationStatus == 0 &&
                                        showYuyue
                                    "
                                    class="margin-right-10"
                                    slot="append"
                                    theme="success"
                                    @click="submitTake"
                                    >{{
                                        $t("erp.aftersales.makeTake", {
                                            defaultValue: "预约上门取件",
                                        })
                                    }}</vButton
                                >
                                <vButton
                                    v-show="
                                        formData.reservationStatus == 1 &&
                                        showYuyue
                                    "
                                    slot="append"
                                    @click="cancelTake"
                                    >{{
                                        $t("erp.aftersales.cancelTake", {
                                            defaultValue: "取消上门取件",
                                        })
                                    }}</vButton
                                >
                            </span>
                        </div>
                    </vCol>
                    <vCol span="12"></vCol>
                </vCol>

                <vCol span="24">
                    <vCol span="12">
                        <div style="height: 30px">
                            <!-- 从渠道订单号添加的退货单，oldreturnStatus为undefined -->
                            <div
                                v-if="
                                    (oldreturnStatus == 'NORETURN' &&
                                        type != 'query') ||
                                    type == 'add'
                                "
                            >
                                <vFormItem
                                    :label="
                                        $t('erp.aftersales.addgoods', {
                                            defaultValue: '添加退货产品',
                                        })
                                    "
                                    class="pull-left"
                                    style="width: 360px"
                                >
                                    <Select
                                        clearable
                                        filterable
                                        v-model="searchErpSku"
                                        ref="zierpselect"
                                        remote
                                        :remote-method="remoteMethod1"
                                        :loading="loading1"
                                        @on-change="getSellerSKU(searchErpSku)"
                                    >
                                        <Option
                                            v-for="json in erpSkusList"
                                            :value="json.name"
                                            :key="json.id"
                                            >{{ json.name }}</Option
                                        >
                                    </Select>
                                </vFormItem>
                                <div class="pull-left margin-left-10">
                                    <vButton
                                        slot="append"
                                        @click="showInvatryBox"
                                        >{{
                                            $t("erp.product.new_add", {
                                                defaultValue: "添加",
                                            })
                                        }}</vButton
                                    >
                                </div>
                                <span
                                    style="
                                        display: inline-block;
                                        line-height: 31px;
                                        margin-left: 10px;
                                    "
                                    class="color-error"
                                    >{{
                                        $t("erp.aftersales.addgoodsnotes", {
                                            defaultValue: "退货单说明",
                                        })
                                    }}</span
                                >
                            </div>
                        </div>
                    </vCol>
                    <vCol span="12" v-if="type != 'query'">
                        <div class="pull-right margin-bottom-20">
                            <div
                                v-if="
                                    oldreturnStatus == 'RETURNING' ||
                                    oldreturnStatus == 'NULLIFY'
                                "
                            >
                                {{ filterStatus(formData.returnStatus) }}
                            </div>
                            <vSelect
                                v-else
                                v-model="formData.returnStatus"
                                style="width: 120px"
                            >
                                <vOption
                                    value="NORETURN"
                                    v-show="
                                        (oldreturnStatus == 'NORETURN' &&
                                            type == 'edit') ||
                                        type == 'add'
                                    "
                                    >{{
                                        $t("erp.aftersales.noreturn", {
                                            defaultValue: "未退货",
                                        })
                                    }}</vOption
                                >
                                <vOption
                                    value="RETURNED"
                                    v-show="
                                        (oldreturnStatus != 'NULLIFY' &&
                                            type == 'edit') ||
                                        type == 'add'
                                    "
                                    >{{
                                        $t("erp.aftersales.returned", {
                                            defaultValue: "已退货",
                                        })
                                    }}</vOption
                                >
                                <!-- <vOption value="RETURNING" v-show="oldreturnStatus!='NULLIFY'">已接收</vOption> -->
                                <vOption value="NULLIFY">{{
                                    $t("erp.aftersales.nullify", {
                                        defaultValue: "已作废",
                                    })
                                }}</vOption>
                            </vSelect>
                        </div>
                    </vCol>
                </vCol>

                <vCol span="24">
                    <vTable
                        class="margin-bottom-20"
                        :columns="columns"
                        :data="datalist"
                        size="small"
                        ref="table"
                        border
                    ></vTable>
                </vCol>
                <vCol span="12">
                    <vFormItem
                        :label="
                            $t('erp.aftersales.shippingname', {
                                defaultValue: '发货人',
                            })
                        "
                        v-if="
                            type == 'query' ||
                            oldreturnStatus == 'RETURNED' ||
                            oldreturnStatus == 'NULLIFY' ||
                            oldreturnStatus == 'RETURNING'
                        "
                    >
                        <div class="font-bold height-32">
                            {{ formData.name }}
                        </div>
                    </vFormItem>
                    <vFormItem
                        v-else
                        :label="
                            $t('erp.aftersales.shippingname', {
                                defaultValue: '发货人',
                            })
                        "
                        :rules="required"
                        prop="name"
                    >
                        <vInput v-model="formData.name"></vInput>
                    </vFormItem>
                </vCol>
                <vCol span="12">
                    <vFormItem
                        :label="
                            $tc('global.common.country', 1, {
                                defaultValue: '国家',
                            })
                        "
                        v-if="
                            type == 'query' ||
                            oldreturnStatus == 'RETURNED' ||
                            oldreturnStatus == 'NULLIFY' ||
                            oldreturnStatus == 'RETURNING'
                        "
                    >
                        <div class="font-bold height-32">
                            {{ formData.country }}
                        </div>
                    </vFormItem>
                    <vFormItem
                        v-else
                        :label="
                            $tc('global.common.country', 1, {
                                defaultValue: '国家',
                            })
                        "
                        :rules="required"
                        prop="country"
                    >
                        <Select
                            clearable
                            filterable
                            v-model="formData.country"
                            @on-change="oneCountry(formData.country, 'edit')"
                        >
                            <Option
                                v-for="(json, index) in countries"
                                :value="json.code"
                                :key="index"
                                >{{ json.code }}</Option
                            >
                        </Select>
                    </vFormItem>
                </vCol>
                <vCol span="12">
                    <vFormItem
                        :label="
                            $t('erp.b2border.addressone', {
                                defaultValue: '地址1',
                            })
                        "
                        v-if="
                            type == 'query' ||
                            oldreturnStatus == 'RETURNED' ||
                            oldreturnStatus == 'NULLIFY' ||
                            oldreturnStatus == 'RETURNING'
                        "
                    >
                        <div class="font-bold height-32">
                            {{ formData.address1 }}
                        </div>
                    </vFormItem>
                    <vFormItem
                        v-else
                        :label="
                            $t('erp.b2border.addressone', {
                                defaultValue: '地址1',
                            })
                        "
                        :rules="required"
                        prop="address1"
                    >
                        <vInput v-model="formData.address1"></vInput>
                    </vFormItem>
                </vCol>
                <vCol span="12">
                    <vFormItem
                        :label="
                            $t('erp.b2c.state_province', {
                                defaultValue: '州/省份',
                            })
                        "
                        v-if="
                            type == 'query' ||
                            oldreturnStatus == 'RETURNED' ||
                            oldreturnStatus == 'NULLIFY' ||
                            oldreturnStatus == 'RETURNING'
                        "
                    >
                        <div class="font-bold height-32">
                            {{ formData.state }}
                        </div>
                    </vFormItem>
                    <vFormItem
                        v-else
                        :label="
                            $t('erp.b2c.state_province', {
                                defaultValue: '州/省份',
                            })
                        "
                        :rules="required"
                        prop="state"
                    >
                        <div class="receive">
                            <AutoComplete
                                v-model="formData.state"
                                :data="states"
                                :filter-method="filterMethod"
                            ></AutoComplete>
                        </div>
                    </vFormItem>
                </vCol>
                <vCol span="12">
                    <vFormItem
                        :label="
                            $t('erp.b2border.addresstwo', {
                                defaultValue: '地址2',
                            })
                        "
                    >
                        <div
                            class="font-bold height-32"
                            v-if="
                                type == 'query' ||
                                oldreturnStatus == 'RETURNED' ||
                                oldreturnStatus == 'NULLIFY' ||
                                oldreturnStatus == 'RETURNING'
                            "
                        >
                            {{ formData.address2 }}
                        </div>
                        <vInput v-else v-model="formData.address2"></vInput>
                    </vFormItem>
                </vCol>
                <vCol span="12">
                    <vFormItem
                        :label="
                            $t('erp.b2c.zip_code', { defaultValue: '邮编' })
                        "
                        v-if="
                            type == 'query' ||
                            oldreturnStatus == 'RETURNED' ||
                            oldreturnStatus == 'NULLIFY' ||
                            oldreturnStatus == 'RETURNING'
                        "
                    >
                        <div class="font-bold height-32">
                            {{ formData.postal }}
                        </div>
                    </vFormItem>
                    <vFormItem
                        v-else
                        :label="
                            $t('erp.b2c.zip_code', { defaultValue: '邮编' })
                        "
                        :rules="required"
                        prop="postal"
                    >
                        <vInput v-model="formData.postal"></vInput>
                    </vFormItem>
                </vCol>
                <vCol span="12">
                    <vFormItem
                        :label="$t('erp.b2c.city', { defaultValue: '城市' })"
                        v-if="
                            type == 'query' ||
                            oldreturnStatus == 'RETURNED' ||
                            oldreturnStatus == 'NULLIFY' ||
                            oldreturnStatus == 'RETURNING'
                        "
                    >
                        <div class="font-bold height-32">
                            {{ formData.city }}
                        </div>
                    </vFormItem>
                    <vFormItem
                        v-else
                        :label="$t('erp.b2c.city', { defaultValue: '城市' })"
                        :rules="required"
                        prop="city"
                    >
                        <vInput v-model="formData.city"></vInput>
                    </vFormItem>
                </vCol>
                <vCol span="12">
                    <vFormItem
                        :label="$t('erp.b2c.phone', { defaultValue: '电话' })"
                        v-if="
                            type == 'query' ||
                            oldreturnStatus == 'RETURNED' ||
                            oldreturnStatus == 'NULLIFY' ||
                            oldreturnStatus == 'RETURNING'
                        "
                    >
                        <div class="font-bold height-32">
                            {{ formData.phone }}
                        </div>
                    </vFormItem>
                    <vFormItem
                        v-else
                        :label="$t('erp.b2c.phone', { defaultValue: '电话' })"
                        :rules="required"
                        prop="phone"
                    >
                        <vInput v-model="formData.phone"></vInput>
                    </vFormItem>
                </vCol>
                <vCol span="24">
                    <vFormItem
                        style="width: 50%"
                        :label="
                            $t('erp.aftersales.rewarehouse', {
                                defaultValue: '退货仓库',
                            })
                        "
                        v-if="
                            type == 'query' ||
                            oldreturnStatus == 'RETURNED' ||
                            oldreturnStatus == 'NULLIFY' ||
                            oldreturnStatus == 'RETURNING'
                        "
                    >
                        <div class="font-bold height-32">
                            {{ formData.orgWarehouseCode || "Other" }}
                        </div>
                    </vFormItem>
                    <vFormItem
                        style="width: 50%"
                        v-else
                        :label="
                            $t('erp.aftersales.rewarehouse', {
                                defaultValue: '退货仓库',
                            })
                        "
                        :rules="required"
                        prop="orgWarehouseId"
                    >
                        <vSelect
                            clearable
                            filterable
                            v-model="formData.orgWarehouseId"
                            @on-change="
                                changeShowOther(formData.orgWarehouseId)
                            "
                        >
                            <vOption value="0">Other</vOption>
                            <vOption
                                v-for="(
                                    item, index
                                ) in getFilterDisabledWarehouse"
                                :key="index"
                                :value="item.value"
                                >{{ item.label }}</vOption
                            >
                        </vSelect>
                    </vFormItem>
                </vCol>
                <!-- --------------------退货仓库为other------------------ -->
                <vCol span="12">
                    <vFormItem
                        :label="
                            $t('erp.b2c.recipients', { defaultValue: '收件人' })
                        "
                        v-if="type == 'query' && showQuery"
                    >
                        <div class="font-bold height-32">
                            {{ formData.orderServiceAddress.receiverName }}
                        </div>
                    </vFormItem>
                    <vFormItem
                        v-if="type != 'query' && showOther"
                        :label="
                            $t('erp.b2c.recipients', { defaultValue: '收件人' })
                        "
                        :rules="required"
                        prop="orderServiceAddress.receiverName"
                    >
                        <vInput
                            v-model="formData.orderServiceAddress.receiverName"
                        ></vInput>
                    </vFormItem>
                </vCol>
                <vCol span="12">
                    <vFormItem
                        :label="
                            $tc('global.common.country', 1, {
                                defaultValue: '国家',
                            })
                        "
                        v-if="type == 'query' && showQuery"
                    >
                        <div class="font-bold height-32">
                            {{ formData.orderServiceAddress.countryCode }}
                        </div>
                    </vFormItem>
                    <vFormItem
                        v-if="type != 'query' && showOther"
                        :label="
                            $tc('global.common.country', 1, {
                                defaultValue: '国家',
                            })
                        "
                        :rules="required"
                        prop="orderServiceAddress.countryCode"
                    >
                        <Select
                            clearable
                            filterable
                            v-model="formData.orderServiceAddress.countryCode"
                            @on-change="
                                otheroneCountry(
                                    formData.orderServiceAddress.countryCode,
                                    'edit'
                                )
                            "
                        >
                            <Option
                                v-for="(json, index) in countries"
                                :value="json.code"
                                :key="index"
                                >{{ json.code }}</Option
                            >
                        </Select>
                    </vFormItem>
                </vCol>
                <vCol span="12">
                    <vFormItem
                        :label="
                            $t('erp.b2border.addressone', {
                                defaultValue: '地址1',
                            })
                        "
                        v-if="type == 'query' && showQuery"
                    >
                        <div class="font-bold height-32">
                            {{ formData.orderServiceAddress.addressline1 }}
                        </div>
                    </vFormItem>
                    <vFormItem
                        v-if="type != 'query' && showOther"
                        :label="
                            $t('erp.b2border.addressone', {
                                defaultValue: '地址1',
                            })
                        "
                        :rules="required"
                        prop="orderServiceAddress.addressline1"
                    >
                        <vInput
                            v-model="formData.orderServiceAddress.addressline1"
                        ></vInput>
                    </vFormItem>
                </vCol>
                <vCol span="12">
                    <vFormItem
                        :label="
                            $t('erp.b2c.state_province', {
                                defaultValue: '州/省份',
                            })
                        "
                        v-if="type == 'query' && showQuery"
                    >
                        <div class="font-bold height-32">
                            {{ formData.orderServiceAddress.state }}
                        </div>
                    </vFormItem>
                    <vFormItem
                        v-if="type != 'query' && showOther"
                        :label="
                            $t('erp.b2c.state_province', {
                                defaultValue: '州/省份',
                            })
                        "
                        :rules="required"
                        prop="orderServiceAddress.state"
                    >
                        <div class="receive">
                            <AutoComplete
                                v-model="formData.orderServiceAddress.state"
                                :data="otherstates"
                                :filter-method="filterMethod"
                            ></AutoComplete>
                        </div>
                    </vFormItem>
                </vCol>
                <vCol span="12">
                    <vFormItem
                        :label="
                            $t('erp.b2border.addresstwo', {
                                defaultValue: '地址2',
                            })
                        "
                        v-if="type == 'query' && showQuery"
                    >
                        <div class="font-bold height-32">
                            {{ formData.orderServiceAddress.addressline2 }}
                        </div>
                    </vFormItem>
                    <vFormItem
                        v-if="type != 'query' && showOther"
                        :label="
                            $t('erp.b2border.addresstwo', {
                                defaultValue: '地址2',
                            })
                        "
                    >
                        <vInput
                            v-model="formData.orderServiceAddress.addressline2"
                        ></vInput>
                    </vFormItem>
                </vCol>
                <vCol span="12">
                    <vFormItem
                        :label="
                            $t('erp.b2c.zip_code', { defaultValue: '邮编' })
                        "
                        v-if="type == 'query' && showQuery"
                    >
                        <div class="font-bold height-32">
                            {{ formData.orderServiceAddress.postalCode }}
                        </div>
                    </vFormItem>
                    <vFormItem
                        v-if="type != 'query' && showOther"
                        :label="
                            $t('erp.b2c.zip_code', { defaultValue: '邮编' })
                        "
                        :rules="required"
                        prop="orderServiceAddress.postalCode"
                    >
                        <vInput
                            v-model="formData.orderServiceAddress.postalCode"
                        ></vInput>
                    </vFormItem>
                </vCol>
                <vCol span="12">
                    <vFormItem
                        :label="$t('erp.b2c.city', { defaultValue: '城市' })"
                        v-if="type == 'query' && showQuery"
                    >
                        <div class="font-bold height-32">
                            {{ formData.orderServiceAddress.city }}
                        </div>
                    </vFormItem>
                    <vFormItem
                        v-if="type != 'query' && showOther"
                        :label="$t('erp.b2c.city', { defaultValue: '城市' })"
                        :rules="required"
                        prop="orderServiceAddress.city"
                    >
                        <vInput
                            v-model="formData.orderServiceAddress.city"
                        ></vInput>
                    </vFormItem>
                </vCol>
                <vCol span="12">
                    <vFormItem
                        :label="$t('erp.b2c.phone', { defaultValue: '电话' })"
                        v-if="type == 'query' && showQuery"
                    >
                        <div class="font-bold height-32">
                            {{ formData.orderServiceAddress.phone }}
                        </div>
                    </vFormItem>
                    <vFormItem
                        v-if="type != 'query' && showOther"
                        :label="$t('erp.b2c.phone', { defaultValue: '电话' })"
                        :rules="required"
                        prop="orderServiceAddress.phone"
                    >
                        <vInput
                            v-model="formData.orderServiceAddress.phone"
                        ></vInput>
                    </vFormItem>
                </vCol>
                <!-- --------------------退货仓库为other------------------ -->

                <vCol span="12">
                    <vFormItem
                        :label="
                            $t('erp.b2c.3rd_account', {
                                defaultValue: '3rd账号',
                            })
                        "
                        v-if="
                            type == 'query' ||
                            oldreturnStatus == 'RETURNED' ||
                            oldreturnStatus == 'NULLIFY' ||
                            oldreturnStatus == 'RETURNING'
                        "
                    >
                        <div class="font-bold height-32">
                            {{ formData.thirdPartyAccount }}
                        </div>
                    </vFormItem>
                    <vFormItem
                        v-else
                        :label="
                            $t('erp.b2c.3rd_account', {
                                defaultValue: '3rd账号',
                            })
                        "
                    >
                        <vInput v-model="formData.thirdPartyAccount"></vInput>
                    </vFormItem>
                </vCol>
                <vCol span="12">
                    <vFormItem
                        :label="
                            $t('erp.aftersales.returndate', {
                                defaultValue: '退货日期',
                            })
                        "
                        v-if="
                            type == 'query' ||
                            oldreturnStatus == 'RETURNED' ||
                            oldreturnStatus == 'NULLIFY' ||
                            oldreturnStatus == 'RETURNING'
                        "
                    >
                        <div class="font-bold height-32">
                            {{ formData.returnAt }}
                        </div>
                    </vFormItem>
                    <vFormItem
                        v-else
                        :label="
                            $t('erp.aftersales.returndate', {
                                defaultValue: '退货日期',
                            })
                        "
                        :rules="required"
                        prop="returnAt"
                    >
                        <vDatepicker
                            v-model="formData.returnAt"
                            format="yyyy-mm-dd HH:MM:SS"
                            style="width: 100%"
                        ></vDatepicker>
                    </vFormItem>
                </vCol>
                <vCol span="12">
                    <vFormItem
                        :label="
                            $t('erp.aftersales.returnremark', {
                                defaultValue: '退货原因',
                            })
                        "
                    >
                        <div
                            class="font-bold height-32"
                            v-if="
                                type == 'query' ||
                                oldreturnStatus == 'RETURNED' ||
                                oldreturnStatus == 'NULLIFY' ||
                                oldreturnStatus == 'RETURNING'
                            "
                        >
                            {{ formData.returnExplain }}
                        </div>
                        <vTextarea
                            v-else
                            v-model="formData.returnExplain"
                            style="width: 100%"
                            :placeholder="
                                this.$t('boss.aftersales.inputs_are_allowed', {
                                    defaultValue: '最多可输入100个',
                                })
                            "
                            maxlength="100"
                        ></vTextarea>
                    </vFormItem>
                </vCol>
                <vCol span="12">
                    <vFormItem
                        :label="
                            $t('fbb.costmanage.explain', {
                                defaultValue: '说明',
                            })
                        "
                    >
                        <div
                            class="font-bold height-32"
                            v-if="
                                type == 'query' ||
                                oldreturnStatus == 'RETURNED' ||
                                oldreturnStatus == 'NULLIFY' ||
                                oldreturnStatus == 'RETURNING'
                            "
                        >
                            {{ formData.remark }}
                        </div>
                        <vTextarea
                            v-else
                            v-model="formData.remark"
                            style="width: 100%"
                            :placeholder="
                                this.$t('boss.aftersales.inputs_are_allowed', {
                                    defaultValue: '最多可输入100个',
                                })
                            "
                            maxlength="100"
                        ></vTextarea>
                    </vFormItem>
                </vCol>
                <vCol span="12">
                    <vFormItem
                        :label="
                            $t('erp.aftersales.takedate', {
                                defaultValue: '取件日期',
                            })
                        "
                    >
                        <div class="font-bold height-32">
                            {{ formData.reservationData }}
                        </div>
                    </vFormItem>
                </vCol>
                <vCol span="12">
                    <vFormItem
                        :label="
                            $t('erp.aftersales.taketime', {
                                defaultValue: '取件时间',
                            })
                        "
                    >
                        <div class="font-bold height-32">
                            {{ formData.reservationTime }}
                        </div>
                    </vFormItem>
                </vCol>
                <vCol span="12">
                    <vFormItem
                        :label="
                            $t('erp.aftersales.takecode', {
                                defaultValue: '取件码',
                            })
                        "
                    >
                        <div class="font-bold height-32">
                            {{ formData.pickupnum }}
                        </div>
                    </vFormItem>
                </vCol>
            </vForm>
        </div>
        <!-- 全局弹框 -->
        <compModal
            v-model="modalProps.show"
            v-bind="modalProps"
            @on-confirm="modalProps = {}"
            @on-close="closemodalprops"
        >
            <component
                ref="cusref"
                :is="modalProps.component"
                v-bind="modalProps"
                @on-close="closemodalprops"
                v-on="modalProps.on"
            ></component>
        </compModal>

        <vLoading size="large" transfer :loading="loading2">
            <Icon
                type="ios-loading"
                size="18"
                class="demo-spin-icon-load"
            ></Icon>
            <div>
                {{
                    $t("boss.aftersales.buying_progress", {
                        defaultValue: "购买中",
                    })
                }}
            </div>
        </vLoading>
    </div>
</template>
<script>
import { HttpFindWarehouseCarriers } from "@/service/boss/b2corder";
import { OrgWarehouse } from "@/service/boss/dictionary";

import { mapState, mapGetters } from "vuex";
import { HttpVsSkuList } from "@/service/boss/allot";
import {
    HttpGetFlagAndSku,
    HttpGetErpsku,
    HttpGoodsPush,
    HttpBuyLabel,
    HttpNewBuyLabel,
    HttpSubmitReturn,
    HttpPickReservation,
    HttpCancelReservation,
} from "@/service/aftersales/aftersales";
import { HttpGetContry } from "@/service/boss/dictionary";
import {
    HttpGetStates,
    HttpGetAllCustomerIdCode,
} from "@/service/boss/b2corder";
import { HttpPlatformSystem } from "@/service/managechannel/managechannel";
import compTakeCode from "./takecode.vue";

export default {
    props: [
        "orderServiceBaseInfo",
        "orderServiceReturn",
        "accountFlag",
        "tabledata",
        "comtype",
        "indexid",
        "querytype",
    ],
    components: {
        compTakeCode,
    },
    data() {
        return {
            baseInfo: {},
            datalist: [],
            isAccess: false,
            type: this.$route.params.type,
            formData: {
                orgWarehouseCode: "AUTO",
                returnStatus: "NORETURN",
                orderServiceAddress: {},
            },
            id: this.$route.query.id,
            volumeTypes: [],
            searchErpSku: "",
            erpSkusList: [],
            loading1: false,
            loading2: false,
            addgoodsData: [],
            states: [],
            required: [
                {
                    required: true,
                    message: this.$t("global.common.fill_requiredd", {
                        defaultValue: "该信息不能为空,请填写",
                    }),
                },
            ],
            oldreturnStatus: "NORETURN",
            additemShow: false,
            buyLabelLoading: false,
            showOther: false,
            showQuery: false,
            otherstates: [],
            returnDealList: [
                {
                    value: 0,
                    label: this.$t(
                        "erp.product.handing_method_for_damage_of_return_undetermined",
                        { defaultValue: "客户自提" }
                    ),
                },
                {
                    value: 1,
                    label: this.$t(
                        "erp.product.handing_method_for_damage_of_return_first_warehousing",
                        { defaultValue: "拍照确认" }
                    ),
                },
                {
                    value: 2,
                    label: this.$t("erp.product.destruction", {
                        defaultValue: "销毁",
                    }),
                },
            ],
            warehousesAll: [],
            watchMark: 0,
            modalProps: {
                show: false,
            },
            takeDate: [],
            takeTime: [],
            allDateList: [],
            showYuyue: false,
        };
    },
    created() {
        this.datalist = this.tabledata.concat();
        this.formatter(this.datalist);

        console.log(this.datalist, "this.datalistthis.datalist");

        if (this.comtype == "query") {
            this.type = this.comtype;
            this.id = this.indexid;
        } else if (this.querytype == "query") {
            this.type = this.querytype;
            this.id = this.indexid;
        } else {
            this.type = this.type;
        }
        this.getdata();
        this.getRegoodsMode();
    },
    watch: {
        orderServiceReturn: {
            deep: true,
            handler(val) {
                console.log(val, "val");
                this.formData = { ...this.formData, ...val };

                this.formData.orderServiceAddress =
                    val.orderServiceAddress || {};

                // 判断是否预约上门的
                if (
                    val.orderServiceItemList &&
                    val.orderServiceItemList.length > 0
                ) {
                    val.orderServiceItemList.map((item) => {
                        if (item.url) {
                            this.showYuyue = true;
                        }
                    });
                }
                if (this.tabledata) {
                    console.log(this.tabledata, "this.tabledata");
                    if (this.watchMark == 0) {
                        this.datalist = this.tabledata.concat();
                        this.watchMark = 1;
                    }
                    if (this.type == "add" || this.type == "query") {
                        this.datalist = this.tabledata.concat();
                    }
                    this.formatter(this.datalist);
                }

                if (val.orgWarehouseId) {
                    this.oldreturnStatus = val.returnStatus;
                }

                if (this.formData.orgWarehouseId == 0 && this.type == "query") {
                    this.showQuery = true;
                } else if (
                    this.formData.orgWarehouseId == 0 &&
                    this.type != "query"
                ) {
                    this.showOther = true;
                }
            },
        },
    },
    computed: {
        // ...mapState('boss',['warehouseList']),
        ...mapState("boss", ["countries"]),
        ...mapGetters("dictionary", ["getFilterDisabledWarehouse"]),
        // warehousesAll(){
        //     return this.getNewWarehouseIdList.filter(function(item){
        //         return item.attach.item.warehouseType !== 4
        //     })
        // },
        packStatus() {
            return [
                {
                    value: 0,
                    label: "UNKNOWN",
                    color: "",
                },
                {
                    value: 1,
                    label: "PRE TRANSIT",
                    color: "color-success",
                },
                {
                    value: 2,
                    label: "IN TRANSIT",
                    color: "color-primary",
                },
                {
                    value: 3,
                    label: "OUT FOR DELIVERY",
                    color: "color-warning",
                },
                {
                    value: 4,
                    label: "DELIVERED",
                    color: "",
                },
                {
                    value: 5,
                    label: "AVAILABLE FOR PICKUP",
                    color: "color-success",
                },
                {
                    value: 6,
                    label: "RETURN TO SENDER",
                    color: "color-error",
                },
                {
                    value: 7,
                    label: "FAILURE",
                    color: "color-error",
                },
                {
                    value: 8,
                    label: "CANCELLED",
                    color: "",
                },
                {
                    value: 9,
                    label: "ERROR",
                    color: "color-error",
                },
                {
                    value: 11,
                    label: "Label Created",
                    color: "",
                },
            ];
        },
        columns() {
            let _this = this;
            return [
                {
                    title: "ERP SKU",
                    key: "erpSku",
                    render: (h, { row }) => {
                        return <div>{row.erpSku || "--"}</div>;
                    },
                },
                {
                    title: "Seller SKU",
                    key: "sellerSku",
                    render: (h, { row }) => {
                        return <div>{row.sellerSku || "--"}</div>;
                    },
                },
                {
                    title: this.$t("erp.aftersales.purchase_num", {
                        defaultValue: "购买/已发数量",
                    }),
                    render: (h, { row }) => {
                        return (
                            <div>
                                {row.buyNum}/{row.shippingNum}
                            </div>
                        );
                    },
                },
                {
                    // title: "",
                    key: "returnNum",
                    renderHeader: (h, params) => {
                        if (
                            _this.type == "query" ||
                            _this.oldreturnStatus == "RETURNED" ||
                            _this.oldreturnStatus == "NULLIFY" ||
                            _this.oldreturnStatus == "RETURNING"
                        ) {
                            return h("div", [
                                h(
                                    "strong",
                                    this.$t("erp.aftersales.return_num", {
                                        defaultValue: "退货数量",
                                    })
                                ),
                            ]);
                        } else {
                            return h("div", [
                                h("Icon", {
                                    props: {
                                        type: "ios-medical",
                                        color: "#ed3f14",
                                    },
                                    style: "margin-right:5px",
                                }),
                                h(
                                    "strong",
                                    this.$t("erp.aftersales.return_num", {
                                        defaultValue: "退货数量",
                                    })
                                ),
                            ]);
                        }
                    },
                    render(h, { row, index }) {
                        if (
                            _this.type == "query" ||
                            _this.oldreturnStatus == "RETURNED" ||
                            _this.oldreturnStatus == "NULLIFY" ||
                            _this.oldreturnStatus == "RETURNING" ||
                            row.hasTracking
                        ) {
                            return <div>{row.returnNum}</div>;
                        } else {
                            return h("vInput", {
                                props: {
                                    size: "small",
                                    value: row.returnNum,
                                },
                                on: {
                                    input: (event) => {
                                        row.returnNum = event;
                                        _this.datalist[index] = row;
                                    },
                                },
                            });
                        }
                    },
                },
                {
                    // title: "",
                    // key: 'returnMode',
                    renderHeader: (h, params) => {
                        if (
                            _this.type == "query" ||
                            _this.oldreturnStatus == "RETURNED" ||
                            _this.oldreturnStatus == "NULLIFY" ||
                            _this.oldreturnStatus == "RETURNING"
                        ) {
                            return h("div", [
                                h(
                                    "strong",
                                    this.$t("erp.aftersales.return_way", {
                                        defaultValue: "退货方式",
                                    })
                                ),
                            ]);
                        } else {
                            return h("div", [
                                h("Icon", {
                                    props: {
                                        type: "ios-medical",
                                        color: "#ed3f14",
                                    },
                                    style: "margin-right:5px",
                                }),
                                h(
                                    "strong",
                                    this.$t("erp.aftersales.return_way", {
                                        defaultValue: "退货方式",
                                    })
                                ),
                            ]);
                        }
                    },
                    render(h, { row, index }) {
                        if (
                            _this.type == "query" ||
                            _this.oldreturnStatus == "RETURNED" ||
                            _this.oldreturnStatus == "NULLIFY" ||
                            _this.oldreturnStatus == "RETURNING" ||
                            row.hasTracking
                        ) {
                            return <div>{row.returnMode}</div>;
                        } else {
                            return h(
                                "Select",
                                {
                                    attrs: {
                                        value: _this.datalist[index].returnMode,
                                        transfer: true,
                                        filterable: true,
                                    },
                                    on: {
                                        "on-change": (value) => {
                                            _this.datalist[index].returnMode =
                                                value;
                                        },
                                    },
                                },
                                _this.volumeTypes.map((json) => {
                                    // console.log(json)
                                    return h("Option", {
                                        props: {
                                            value: json.value,
                                            label: json.label,
                                        },
                                    });
                                })
                            );
                        }
                    },
                },
                {
                    title: this.$t(
                        "boss.aftersales.estimated_logistics_costs",
                        {
                            defaultValue: "预估物流费用",
                        }
                    ),
                    width: this.type == "query" ? 120 : 0,
                    render: (h, { row }) => {
                        return <div>{row.shippingFee}</div>;
                    },
                },
                {
                    renderHeader: (h, params) => {
                        if (
                            _this.type == "query" ||
                            _this.oldreturnStatus == "RETURNED" ||
                            _this.oldreturnStatus == "NULLIFY" ||
                            _this.oldreturnStatus == "RETURNING"
                        ) {
                            return h("div", [
                                h(
                                    "strong",
                                    this.$t("erp.aftersales.detail_way", {
                                        defaultValue: "外观破损处理方式",
                                    })
                                ),
                            ]);
                        } else {
                            return h("div", [
                                h("Icon", {
                                    props: {
                                        type: "ios-medical",
                                        color: "#ed3f14",
                                    },
                                    style: "margin-right:5px",
                                }),
                                h(
                                    "strong",
                                    this.$t("erp.aftersales.detail_way", {
                                        defaultValue: "外观破损处理方式",
                                    })
                                ),
                            ]);
                        }
                    },
                    render(h, { row, index }) {
                        if (
                            _this.type == "query" ||
                            _this.oldreturnStatus == "RETURNED" ||
                            _this.oldreturnStatus == "NULLIFY" ||
                            _this.oldreturnStatus == "RETURNING" ||
                            row.hasTracking
                        ) {
                            return (
                                <div>
                                    {row.returnDealMethod == 0
                                        ? this.$t(
                                              "erp.product.handing_method_for_damage_of_return_undetermined",
                                              { defaultValue: "客户自提" }
                                          )
                                        : row.returnDealMethod == 1
                                        ? this.$t(
                                              "erp.product.handing_method_for_damage_of_return_first_warehousing",
                                              { defaultValue: "拍照确认" }
                                          )
                                        : this.$t("erp.product.destruction", {
                                              defaultValue: "销毁",
                                          })}
                                </div>
                            );
                        } else {
                            return h(
                                "Select",
                                {
                                    attrs: {
                                        value: _this.datalist[index]
                                            .returnDealMethod,
                                        transfer: true,
                                        filterable: true,
                                    },
                                    on: {
                                        "on-change": (value) => {
                                            _this.datalist[
                                                index
                                            ].returnDealMethod = value;
                                        },
                                    },
                                },
                                _this.returnDealList.map((json) => {
                                    return h("Option", {
                                        props: {
                                            value: json.value,
                                            label: json.label,
                                        },
                                    });
                                })
                            );
                        }
                    },
                },
                {
                    // title: "",
                    key: "trackingNo",
                    renderHeader: (h, params) => {
                        if (
                            _this.type == "query" ||
                            _this.formData.returnStatus != "RETURNED"
                        ) {
                            return h("div", [h("strong", "Tracking")]);
                        } else {
                            return h("div", [
                                h("Icon", {
                                    props: {
                                        type: "ios-medical",
                                        color: "#ed3f14",
                                    },
                                    style: "margin-right:5px",
                                }),
                                h("strong", "Tracking"),
                            ]);
                        }
                    },
                    render(h, { row, index }) {
                        if (
                            _this.type == "query" ||
                            _this.oldreturnStatus == "RETURNED" ||
                            _this.oldreturnStatus == "NULLIFY" ||
                            _this.oldreturnStatus == "RETURNING" ||
                            row.hasTracking
                        ) {
                            // return <div>{row.trackingNo}</div>
                            let ele = (
                                <div>
                                    <a target="_blank" href={row.url}>
                                        {row.trackingNo}
                                    </a>
                                </div>
                            );
                            if (!row.url) {
                                ele = (
                                    <div>
                                        <div>{row.trackingNo}</div>
                                    </div>
                                );
                            }
                            return ele;
                        } else {
                            return h("vInput", {
                                props: {
                                    size: "small",
                                    value: row.trackingNo,
                                },
                                on: {
                                    input: (event) => {
                                        row.trackingNo = event;
                                        _this.datalist[index] = row;
                                    },
                                },
                            });
                        }
                    },
                },
                {
                    title: this.$t("boss.aftersales.logistics_status", {
                        defaultValue: "物流状态",
                    }),
                    width: _this.type == "query" ? 120 : 0,
                    render: (h, { row }) => {
                        let trackNo = row.trackingNo;
                        let url = "";
                        let font = _this.getLogistics(row.logisticsStatus);
                        if (trackNo.slice(0, 2) === "1Z") {
                            url = `https://www.ups.com/track?loc=zh_CN&tracknum=${trackNo}&requester=WT/tracksummary`;
                        } else {
                            url = `https://www.fedex.com/apps/fedextrack/?action=track&tracknumbers=${trackNo}&locale=en_US&cntry_code=ratetools`;
                        }
                        let ele = (
                            <div>
                                <a target="_blank" href={url}>
                                    {font}
                                </a>
                            </div>
                        );
                        return ele;
                    },
                },
                {
                    title: this.$t("global.common.actions", {
                        defaultValue: "操作",
                    }),
                    width:
                        _this.type == "query" ||
                        _this.oldreturnStatus == "RETURNED" ||
                        _this.oldreturnStatus == "NULLIFY" ||
                        _this.oldreturnStatus == "RETURNING"
                            ? 0
                            : 120,
                    render(h, { row, index }) {
                        return h("div", [
                            h(
                                "Button",
                                {
                                    props: {
                                        type: "error",
                                        size: "small",
                                    },
                                    on: {
                                        click: () => {
                                            _this.removeOne(index);
                                        },
                                    },
                                },
                                this.$t("global.common.delete", {
                                    defaultValue: "删除",
                                })
                            ),
                        ]);
                    },
                },
            ];
        },
    },
    methods: {
        // 预约上门取件、取消上门取件
        submitTake() {
            this.$emit("on-closeCloseable");
            this.modalProps = {
                show: true,
                alert: "primary",
                title: this.$t("erp.aftersales.makeTake", {
                    defaultValue: "预约上门取件",
                }),
                width: 500,
                showDesc: false,
                params: this.id,
                component: "compTakeCode",
                showFooter: false,
                on: {
                    "on-update": () => {
                        this.$emit("on-update");
                        this.modalProps.show = false;
                    },
                },
            };
        },
        cancelTake() {
            this.$emit("on-closeCloseable");
            this.modalProps = {
                show: true,
                alert: "primary",
                title: this.$t("erp.aftersales.cancelTake", {
                    defaultValue: "取消上门取件",
                }),
                width: 500,
                showDesc: false,
                params: { returnId: this.formData.returnId },
                formdata: [
                    {
                        label: this.$t("fbb.alloment.cancel_reason", {
                            defaultValue: "取消原因",
                        }),
                        key: "remark",
                        tag: "vTextarea",
                        span: 24,
                    },
                ],
                ajaxRequest: HttpCancelReservation,
                callback: (res) => {
                    this.$emit("on-update");
                    this.modalProps.show = false;
                },
            };
        },
        closemodalprops() {
            this.$emit("on-openCloseable");
            this.modalProps = {};
        },
        getLogistics(value) {
            let result = this.packStatus.filter((item) => {
                return item.value === value;
            })[0];
            if (!result || !result.label) return <div>--</div>;
            return <span class={result.color}>{result.label}</span>;
        },
        changeShowOther(val) {
            // console.log(val)
            if (val == 0) {
                this.showOther = true;
            } else {
                this.showOther = false;
            }
        },
        repush() {
            HttpGoodsPush({
                id: this.id,
            }).then(
                (res) => {
                    this.$VMessage.success(res.message);
                },
                (err) => {
                    this.$VMessage.error({
                        content: err.message,
                        duration: 30,
                        closable: true,
                    });
                }
            );
        },
        getdata() {
            let gmttome = this.$moment()
                .tz("GMT")
                .format("YYYY-MM-DD HH:mm:ss");
            this.formData.returnAt = gmttome;
        },
        // 如果包含trackingNo，说明已经购买过面单，则整行不可编辑
        formatter(datalist) {
            for (let i = 0; i < datalist.length; i++) {
                if (datalist[i]) {
                    if (datalist[i].trackingNo) {
                        datalist[i].hasTracking = true;
                    }
                    // datalist的returnDealMethod赋值请求
                    if (!datalist[i].returnDealMethod && this.type == "add") {
                        HttpGetErpsku({
                            "search[EQ_id]": datalist[i].productId,
                        }).then((res) => {
                            datalist[i].returnDealMethod =
                                res.data.content[0].returnDealMethod;
                        });
                    }
                    // 带出退货方式
                    if (!datalist[i].returnMode) {
                        // this.$set(datalist,i,{returnMode:'FEDXG'})
                        datalist[i].returnMode = "FEDXG";
                    }
                }
            }
        },
        remoteMethod1(query) {
            this.loading1 = true;
            HttpGetErpsku({ "search[CN_erpSku]": query, rows: 50 }).then(
                (res) => {
                    // console.log(res)
                    this.loading1 = false;
                    this.erpSkusList = res.data.content.map((item) => {
                        return {
                            name: item.erpSku,
                            id: item.id,
                            title: item.nameEn,
                            returnDealMethod: item.returnDealMethod,
                        };
                    });
                }
            );
        },
        // 校验退货单表格数据
        async validReturnData() {
            let mode = 0;
            let tempArr = [];
            await this.datalist.map((item) => {
                // 填写必填项
                if (!item.returnNum || !item.returnMode) {
                    mode = 0;
                    return (this.isAccess = false);
                }
                // 没有trackingNo的退货数量必须为1
                if (!item.trackingNo && item.returnNum != "1") {
                    mode = 1;
                    return (this.isAccess = false);
                }
                // 有tracking的行不做发货方式检测
                if (!item.trackingNo) {
                    tempArr.push(item.returnMode);
                }
                this.isAccess = true;
            });
            let returnModeSet = new Set(tempArr);
            // tracking为空的行发货方式必须相同
            if (returnModeSet.size > 1) {
                mode = 2;
                this.isAccess = false;
            }

            let str = this.$t("global.form.require", {
                defaultValue: "请填写必填项",
            });
            if (!this.isAccess) {
                switch (mode) {
                    case 0:
                        str = this.$t("global.form.require", {
                            defaultValue: "请填写必填项",
                        });
                        break;
                    case 1:
                        str = this.$t("erp.aftersales.rownumone", {
                            defaultValue: "购买面单时每行的退货数量只能为1",
                        });
                        break;
                    case 2:
                        str = this.$t("erp.aftersales.rowsameway", {
                            defaultValue: "购买面单的行需要相同的发货方式",
                        });
                        break;
                }
                this.$VMessage.warning(str);
            }
            return this.isAccess;
        },
        // 购买面单
        buyLabel() {
            let p1 = this.validReturnData();
            let p2 = this.validate();
            Promise.all([p1, p2]).then((res) => {
                if (!res[0] || !res[1]) {
                    return;
                }
                let {
                    replacementId,
                    replacementOrderNo,
                    replacementOrderId,
                    replacementStatus,
                    shippingMode,
                    carrierAddition,
                    mobilePhone,
                    replacementAt,
                    replacementExplain,
                    ...orderServiceReturn
                } = this.formData;
                // 要从购买面单列表中删除的index数组
                let spliceArr = [];
                let datalist = this.datalist.map((item, index) => {
                    if (item.hasTracking || item.trackingNo) {
                        spliceArr.push(index);
                    }
                    item.returnNum = parseInt(item.returnNum);
                    let {
                        questionNum,
                        reasonId,
                        refundAmount,
                        replacementNum,
                        isInsurance,
                        insuranceRate,
                        serviceSummaryRequest,
                        hasTracking,
                        _index,
                        ...params
                    } = item;
                    return params;
                });
                for (let i = spliceArr.length - 1; i >= 0; i--) {
                    datalist.splice(spliceArr[i], 1);
                }
                if (datalist.length < 1) {
                    return this.$VMessage.error(
                        this.$t("erp.aftersales.nopurchsepro", {
                            defaultValue: "没有需要购买面单的产品",
                        })
                    );
                }
                orderServiceReturn = {
                    ...orderServiceReturn,
                    orderServiceItemList: [...datalist],
                };
                this.buyLabelLoading = true;

                HttpBuyLabel({
                    orderServiceBaseInfo: { ...this.orderServiceBaseInfo },
                    orderServiceReturn: orderServiceReturn,
                }).then(
                    (res) => {
                        let index = 0;
                        for (let i = 0; i < this.datalist.length; i++) {
                            if (this.datalist[i].hasTracking) {
                                continue;
                            }
                            for (; index < res.data.length; ) {
                                this.datalist[i].trackingNo =
                                    res.data[index].trackNo;
                                this.datalist[i].url = res.data[index].url;
                                this.datalist[i].hasTracking = true;
                                index++;
                                break;
                            }
                        }
                        this.buyLabelLoading = false;
                    },
                    (err) => {
                        this.buyLabelLoading = false;
                        this.$VMessage.error({
                            content: err.message,
                            duration: 30,
                            closable: true,
                        });
                    }
                );
            });
        },
        //新购买面单逻辑
        buyNewLabel() {
            this.loading2 = true;
            // let p1 = this.validReturnData()
            // let p2 = this.validate()
            // Promise.all([p1, p2]).then( (res) => {
            //     if (!res[0] || !res[1]) {
            //         return
            //     }
            HttpNewBuyLabel({
                id: this.id,
            }).then(
                (res) => {
                    this.loading2 = false;
                    this.$VMessage.success(res.message);
                    this.$emit("on-update");
                },
                (err) => {
                    this.loading2 = false;
                    this.$VMessage.error({
                        content: err.message,
                        duration: 30,
                        closable: true,
                    });
                }
            );
            // })
        },
        // 提交退货
        submitGoods() {
            HttpSubmitReturn({
                id: this.id,
            }).then(
                (res) => {
                    this.$VMessage.success(res.message);
                    this.$emit("on-update");
                },
                (err) => {
                    this.$VMessage.error({
                        content: err.message,
                        duration: 30,
                        closable: true,
                    });
                }
            );
        },
        getSellerSKU(erpsku) {
            // console.log(erpsku)
            HttpGetFlagAndSku({
                accountFlag: this.accountFlag,
                erpSku: erpsku,
            }).then(
                (res) => {
                    // console.log(res)
                    this.additemShow = false;
                    this.addgoodsData = res.data;
                },
                (err) => {
                    this.additemShow = false;
                    this.addgoodsData = null;
                }
            );
        },
        filterMethod(value, option) {
            return option.toLowerCase().indexOf(value.toLowerCase()) !== -1;
        },
        getRegoodsMode() {
            HttpGetAllCustomerIdCode().then(
                (res) => {
                    this.volumeTypes = res.data.map((item) => {
                        return {
                            label: `${item.code}(${item.carrierServiceName})`,
                            value: item.code,
                        };
                    });
                },
                (err) => {
                    this.$VMessage.error({
                        content: err.message,
                        duration: 30,
                        closable: true,
                    });
                }
            );

            // 请求仓库接口
            // OrgWarehouse({'search[CN_property]':1}).then(res=>{
            //     this.warehousesAll = res.data.map(item=>{
            //         return {
            //             value: item.id,
            //             label: item.code + '(' + item.title+ ')',
            //         }
            //     })
            // },err=>{
            // })
        },
        showInvatryBox() {
            // this.addgoodsData.map(item=>{
            // 增加判断不能添加退货产品为空
            if (!this.searchErpSku) {
                return this.$Message.error("添加退货产品不能为空！");
            }
            let erpskuone =
                this.erpSkusList.filter((item) => {
                    return item.name === this.searchErpSku;
                })[0] || {};
            // console.log(erpskuone)

            let data = {
                productId: erpskuone.id,
                erpSku: erpskuone.name,
                returnDealMethod: erpskuone.returnDealMethod,
                sellerSku:
                    this.addgoodsData === null
                        ? "--"
                        : this.addgoodsData.sellerSku,
                buyNum: 0,
                shippingNum: 0,
                returnNum: "",
                returnMode: "FEDXG",
                trackingNo: "",
                hasTracking: false,
            };
            this.datalist.push(data);
            // })
        },
        removeOne(index) {
            this.datalist.splice(index, 1);
        },
        oneCountry(code, type) {
            HttpGetContry({
                "search[EQ_depth]": 2,
                "search[EQ_code]": code,
            }).then(
                (res) => {
                    let onecode = res.data[0];
                    this.getStates(onecode.id, type);
                },
                (err) => {}
            );
        },
        otheroneCountry(code, type) {
            HttpGetContry({
                "search[EQ_depth]": 2,
                "search[EQ_code]": code,
            }).then(
                (res) => {
                    let onecode = res.data[0];
                    this.othergetStates(onecode.id, type);
                },
                (err) => {}
            );
        },
        getStates(parid, type) {
            if (type == "edit") {
                this.formData.state = "";
            }
            this.states = [];
            HttpGetStates({
                "search[EQ_depth]": 4,
                "search[EQ_parentId]": parid,
            }).then(
                (res) => {
                    let array = res.data;
                    array.map((item) => {
                        this.states.push(item.code);
                    });
                },
                (err) => {}
            );
        },
        othergetStates(parid, type) {
            if (type == "edit") {
                this.formData.orderServiceAddress.state = "";
            }
            this.otherstates = [];
            HttpGetStates({
                "search[EQ_depth]": 4,
                "search[EQ_parentId]": parid,
            }).then(
                (res) => {
                    let array = res.data;
                    array.map((item) => {
                        this.otherstates.push(item.code);
                    });
                },
                (err) => {}
            );
        },
        async validate() {
            // console.log(123123)
            const bool1 = await this.$refs["returnform"].validate();
            // console.log(bool1)
            if (!bool1) {
                this.$VMessage.warning(
                    this.$t("global.form.require", {
                        defaultValue: "请填写必填项",
                    })
                );
            }
            return bool1;
        },
        filterStatus(val) {
            let status = "";
            switch (val) {
                case "NORETURN":
                    status = this.$t("erp.aftersales.noreturn", {
                        defaultValue: "未退货",
                    });
                    break;
                case "RETURNED":
                    status = this.$t("erp.aftersales.returned", {
                        defaultValue: "已退货",
                    });
                    break;
                case "RETURNING":
                    status = this.$t("erp.aftersales.returning", {
                        defaultValue: "已接收",
                    });
                    break;
                case "NULLIFY":
                    status = this.$t("erp.aftersales.nullify", {
                        defaultValue: "已作废",
                    });
                    break;
            }
            return status;
        },
    },
};
</script>
